import axios, { AxiosResponse } from "axios";
import { OrganizationNameRequest } from "../OrganizationForm";
import { ApplicationApi } from "../../../Routing";

/**
 * テナント情報管理 API
 */
export class OrganizationService {

  // テナントの名前一覧取得API
  findOrganizationNameList = async (
    param: OrganizationNameRequest
  ): Promise<AxiosResponse> => {
    try {
      const res: AxiosResponse = await axios.post(
        ApplicationApi.organizationName.apiUrl(),
        param
      );
      return res;
    } catch (err) {
      throw err;
    }
  };
}